export enum IssueTypes {
    BUG= "BUG",
    NEW_FEATURE= "NEW_FEATURE"
}
